<template>
  <div>
    <!-- <v-flex class="d-flex">
      <div class="col-5">
        <v-text-field outlined dense v-model="users.search" :label="$t('searchLabel')" append-icon="mdi-magnify"
          single-line hide-details>
        </v-text-field>
      </div>
    </v-flex> -->
    <v-data-table class="overflow-y-auto" :options.sync="options" :footer-props="users.footerProps" :server-items-length="1" :headers="users.headers" :items="users.values" :loading="loading"
      :loading-text="$t('tableLoadingLabel')">
      <template #item.active="{item}">
        {{item.active ? $t('trueLabel') : $t('falseLabel') }}
      </template>
      <template #item.locked="{item}">
        {{item.locked ? $t('trueLabel') : $t('falseLabel') }}
      </template>
      <template #item.actions="{ item }">
        <v-dialog v-if="canLock" v-model="lockUserDialog" max-width="800px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn min-width="100px" v-if="item.locked" @click="
                () => {
                  selectedUser = item;
                  isLock = false;
                  isUnlock = true;
                }
              " class="white--text" small color="green my-2" v-bind="attrs" v-on="on">
              <v-icon left class="mr-4"> mdi-account-cog </v-icon>
              {{ $t("unlockLabel") }}
            </v-btn>
            <v-btn v-else min-width="100px" class="white--text" @click="
                () => {
                  selectedUser = item;
                  isLock = true;
                  isUnlock = false;
                }
              " small color="red my-2" v-bind="attrs" v-on="on">
              <v-icon left class="mr-4"> mdi-account-cog </v-icon>
              {{ $t("lockLabel") }}
            </v-btn>
          </template>
          <v-card class="pa-10">
            <div>
              <v-card-title class="justify-center">
                <span class="headline">{{
                  isLock ? $t("lockUserLabel") : $t("unlockUserLabel")
                }}</span>
              </v-card-title>

              <v-card-text v-if="isLock">
                <v-container>
                  <v-row>
                    <p class="body-1 text-center">
                      {{ $t("lockUserText") }}
                    </p>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-text v-else>
                <v-container>
                  <v-row>
                    <p class="body-1 text-center">
                      {{ $t("unlockUserText") }}
                    </p>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions class="d-flex justify-center align-center">
                <v-btn v-if="isLock" width="150" class="white--text px-10" color="red" @click="lockUser()">
                  {{ $t("lockUserLabel") }}
                </v-btn>

                <v-btn v-else width="150" class="white--text px-10" color="green" @click="unlockUser()">
                  {{ $t("lockUserLabel") }}
                </v-btn>

                <v-btn width="150" class="primary px-2" color="" @click="() => (lockUserDialog = false)">
                  {{ $t("cancelLabel") }}</v-btn>
              </v-card-actions>
            </div>
          </v-card>
        </v-dialog>
        <v-btn min-width="100px" class="my-1 ml-4 primary--text" small outlined :to="{ name: 'SalesPartnerCompanyDetails' , params: { companyId: companyId, userId: item.id} }">
          {{ $t("viewUserLabel") }}
        </v-btn>
      </template>
      <template v-slot:no-data>
        {{$t('noDataAvailable')}}
      </template>
      <template v-slot:no-results>
        {{$t('noDataAvailable')}}
      </template>
    </v-data-table>
    <v-pagination v-model="page" :length="pageCount" @input="getUsers()"></v-pagination>

  </div>
</template>
<script>
  import UserTypes from "../auth/userTypes";

  export default {
    name: "PartenershipSaleUsersTable",
    data() {
      return {
        options: {},
        page: 1,
        pageCount: 1,
        amount: 10,
        sortBy:'',
        sortDesc: null,
        canLock: false,
        selectedUser: {},
        isLock: false,
        isUnlock: false,
        lockUserDialog: false,
        newUsers: {
          users: [],
        },
        loading: false,
        users: {
          search: "",
          headers: [{
              text: this.$t('usersNameLabel') + 'ss',
              value: "userFullName",
            },
            {
              text: this.$t('usersPersonalNoLabel'),
              value: "personalNo",
            },
            {
              text: this.$t('usersEmailLabel'),
              value: "email",
            },
            {
              text: this.$t('usersStatusLabel'),
              value: "active",
            },
            {
              text: this.$t('usersLockedLabel'),
              value: "locked",
            },
            {
              text: "",
              sortable: false,
              value: "actions",
              align: "end",
            },
          ],
          values: [],
          footerProps:{
            'items-per-page-options' : [5, 10, 15, 20, -1],
            'disable-pagination': true,
            'next-icon': null,
            'prev-icon': null,
            'page-text' : '',
            'items-per-page-all-text': this.$t('allLabel'),
            'items-per-page-text': this.$t('rowsPerPageLabel')
          }
        },
        snackbar: {
            show: true,
            message: "",
        }
        
      };
    },
    props: {
      companyId: Number,
      showUserPath: String,
    },
    watch: {
        options: {
            handler(){
                const options = this.options;
                this.amount = options.itemsPerPage
                const sortBy = options.sortBy.length > 0 ? options.sortBy[0] : '';
                const sortDesc = options.sortDesc.length > 0 ? options.sortDesc[0] : null;
                this.sortBy = sortBy;
                this.sortDesc = sortDesc;
                this.getUsers();
            },
            deep: true
        }
    },
    methods: {
      getUsers() {
        let companyId = this.$props.companyId;
        this.axios
          .get("/api/user/getbycompanyandtype", {
            params: {
              companyId: this.$props.companyId,
              userType: UserTypes.SalesPartnershipSales,
              amount: this.amount,
              page: this.page,
              sortBy: this.sortBy,
              sortDesc: this.sortDesc
            },
          })
          .then((response) => {
            if (response.data != null){
              this.users.values = response.data.users;
              this.pageCount = response.data.pages;
            }
            this.loading = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      },

      lockUser() {
        var data = {
          Id: this.selectedUser.id,
        };
        this.axios
          .post("api/user/lockuser", data)
          .then((response) => {
            let index = this.users.values
              .map((item) => {
                return item.id;
              })
              .indexOf(this.selectedUser.id);
            this.users.values.splice(index, 1, response.data);
            this.selectedUser = {};
            this.isLock = false;
            this.isUnlock = false;
            this.lockUserDialog = false;
            this.snackbar.message = this.$t("userLockedLabel")
            this.$EventBus.$emit("snackbar", this.snackbar);
          })
          .catch((error) => {
            this.loading = false;
            this.snackbar.message = error.message
            this.$EventBus.$emit("snackbar", this.snackbar);
          });
      },

      unlockUser() {
        var data = {
          Id: this.selectedUser.id,
        };
        this.axios
          .post("api/user/unlockuser", data)
          .then((response) => {
            let index = this.users.values
              .map((item) => {
                return item.id;
              })
              .indexOf(this.selectedUser.id);

            this.users.values.splice(index, 1, response.data);
            this.selectedUser = {};
            this.isLock = false;
            this.isUnlock = false;
            this.lockUserDialog = false;
            this.snackbar.message = this.$t("userUnlockedLabel")
            this.$EventBus.$emit("snackbar", this.snackbar);
          })
          .catch((error) => {
            this.loading = false;
            this.snackbar.message = error.message
            this.$EventBus.$emit("snackbar", this.snackbar);
          });
      },
      checkLockAvaliablity() {
        if (
          this.$store.state.user.userType == UserTypes.WertheimAdministrator ||
          this.$store.state.user.userType == UserTypes.SalesPartnershipAdmin
        )
          this.canLock = true;
      },
    },
    mounted() {
      this.getUsers();
      this.checkLockAvaliablity();
    },
  };
</script>
<style scoped>
</style>